import { ASSESSMENT } from '../../Assessment/constants/api'

export const ASSESSMENT_EC = `${ASSESSMENT}ec/` as const
export const ASSESSMENT_EC_REPORT = `${ASSESSMENT}ec/report/` as const
export const ASSESSMENT_EC_UPDATE = `${ASSESSMENT_EC}update` as const
export const ASSESSMENT_EC_OUTCOME_REPORT = `${ASSESSMENT_EC}outcome_report/` as const
export const ASSESSMENT_EC_PAPER = `${ASSESSMENT_EC}paper` as const
export const ASSESSMENT_EC_ALL = `${ASSESSMENT_EC}all` as const
export const ASSESSMENT_EC_CHANGE_STATUS = `${ASSESSMENT_EC}change/status` as const
